import { call, put } from 'redux-saga/effects';
import { types } from '@reducers/projectData';
import { calculatePage } from '@utils/pagination';
import * as Api from '@utils/Api';

export function* fetchProjectStaticFilters({ projectUUID, page }) {
  if (!projectUUID) {
    throw new Error(
      'Missing required parameters for fetching the static filters for a project.'
    );
  }
  const url = calculatePage(
    `projects/${projectUUID}/static-filters?type=multi`,
    page
  );
  const response = yield call(Api.get, url);
  if (!response.success) {
    yield put({
      type: types.PROJECT_STATIC_FILTERS_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown Error',
    });
  } else {
    yield put({
      type: types.PROJECT_STATIC_FILTERS_SUCCESS,
      projectUUID,
      data: response.data,
      url,
    });
  }
}

export function* createProjectStaticFilter({
  projectUUID,
  engine,
  issueName,
  severity,
  displayName,
}) {
  if (!projectUUID || !engine || !issueName) {
    throw new Error(
      'Missing required parameters for creating a static filter for a project.'
    );
  }
  const url = `projects/${projectUUID}/static-filters`;
  const body = {
    type: 'multi',
    engine,
    issue_name: issueName,
    display_name: displayName,
    severity: severity,
  };
  const response = yield call(Api.post, url, body);
  if (!response.success) {
    yield put({
      type: types.PROJECT_CREATE_STATIC_FILTER_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown Error',
    });
  } else {
    yield put({
      type: types.PROJECT_CREATE_STATIC_FILTER_SUCCESS,
      projectUUID,
      filterUUID: response.data.uuid,
    });
  }
}

export function* deleteProjectStaticFilter({ projectUUID, filterUUID }) {
  if (!projectUUID || !filterUUID) {
    throw new Error(
      'Missing required parameters for deleting a static filter for a project.',
      projectUUID,
      filterUUID
    );
  }
  const url = `projects/${projectUUID}/static-filters/${filterUUID}`;
  const response = yield call(Api.del, url);
  if (!response.success) {
    yield put({
      type: types.PROJECT_DELETE_STATIC_FILTER_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown Error',
    });
  } else {
    yield put({
      type: types.PROJECT_DELETE_STATIC_FILTER_SUCCESS,
      projectUUID,
    });
  }
}

export function* fetchProjectPullRequestAuthors({ projectUUID, inputValue }) {
  if (!projectUUID || !inputValue) {
    throw new Error(
      'Missing required parameters for fetching pull request authors for a project.',
      projectUUID,
      inputValue
    );
  }
  const url = `projects/${projectUUID}/pull-requests/authors?username=${inputValue}`;
  const response = yield call(Api.get, url);
  if (!response.success) {
    yield put({
      type: types.PROJECT_PULL_REQUEST_AUTHORS_FAILURE,
      projectUUID,
      error: response.data ? response.data.error_message : 'Unknown Error',
    });
  } else {
    yield put({
      type: types.PROJECT_PULL_REQUEST_AUTHORS_SUCCESS,
      projectUUID,
      data: response.data,
    });
  }
}
